import { createRoot } from "react-dom/client";
import App from "./App";
import { store } from "./store";
import { createTheme, ThemeProvider } from "@mui/material";
import { Provider } from "react-redux";
import React from "react";


//export const config = window.REACT_APP_CONFIG;

const theme = createTheme({
  palette: {
    primary: {
      light: "#0B5983",
      main: "#00558B",
      dark: "#14385F",
      contrastText: "#fff",
    },
  },
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);